module.exports = __webpack_public_path__ + "img/mIconZip.9864490b.svg";